import React, {useCallback, useEffect, useRef, useState} from "react";

export interface EditableBoxProps {
    initialValue: string;
    onAccept: (updatedText: string) => void;
    onCancel: () => void;
    className?: string;
}

export function EditableBox({initialValue, onAccept, onCancel, className}: EditableBoxProps) {
    const [value, setValue] = useState(initialValue);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        textareaRef.current?.focus();
        textareaRef.current?.select();
    }, []);

    const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            const trimmed = value.trim();
            if (trimmed.length > 0) {
                onAccept(trimmed);
            }
        } else if (e.key === "Escape") {
            e.preventDefault();
            onCancel();
        }
    }, [value, onAccept, onCancel]);

    return (
        <div className={`${className ?? ""} block px-2 py-1 border border-neutral-500 bg-gray-really rounded-xl w-full`}>
            <textarea
                ref={textareaRef}
                className="bg-transparent border-none outline-none w-full text-white resize-none p-0 m-0 focus:ring-0 text-sm"
                rows={1}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={onCancel}
            />
        </div>
    );
}

